export function reverseParam(param: number, paramNormalized: boolean, polyLineEdgeLength: number): number {
  const normalized = paramNormalized ? param : param / polyLineEdgeLength;
  const reversedNormalized = 1 - normalized;
  return paramNormalized ? reversedNormalized : reversedNormalized * polyLineEdgeLength;
}
